import { render, staticRenderFns } from "./cost.vue?vue&type=template&id=394f3ad4&scoped=true"
import script from "./cost.vue?vue&type=script&lang=js"
export * from "./cost.vue?vue&type=script&lang=js"
import style0 from "./cost.vue?vue&type=style&index=0&id=394f3ad4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394f3ad4",
  null
  
)

export default component.exports